<template>
    <div>
        <el-row>
            <el-col :span="18" :offset="3" :xs="{'span': 24, 'offset': 0}" v-loading="loading">
                <el-card class="box-card">
                    <el-row :gutter="20" class="hidden-sm-and-down">
                        <el-col :span="5">
                            <el-date-picker
                            :clearable="false"
                            @change="reloadData"
                            v-model="month"
                            type="month"
                            format="MMMM yyyy">
                        </el-date-picker>
                        </el-col>
                        <el-col :span="5">
                            <el-select v-model="selected_category_id" clearable placeholder="Категорії" @change="reloadData">
                                <el-option v-for="item in categories" :key="item.id" :label="item.display_name" :value="item.id">
                            </el-option>
                        </el-select>
                        </el-col>
                    </el-row>
                    <TransactionsTable v-bind:tableData="tableData" v-bind:categories="categories"/>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
// @ is an alias to /src
import TransactionsTable from '@/components/TransactionsTable'

import { getAllTransactions } from "@/api/transactions.api";
import { getAllCategories } from "@/api/categories.api";

import moment from 'moment';

export default {
    name: 'transactions_list',
    components: {
        TransactionsTable
    },
    data: () => ({
        month: '',
        startDate: '',
        endDate: '',
        selected_category_id: '',
        categories: [],
        loading: true,
        tableData: [],
    }),
    async created() {
        this.month = moment();
        this.reloadData()
    },
    methods: {
        async reloadData() {
            this.loading = true;

            this.startDate = moment(this.month).startOf('month');
            this.endDate = moment(this.month).endOf('month');

            let filterParams = {"category": this.selected_category_id, "datetime_after": this.startDate.format(), "datetime_before": this.endDate.format() };
            const transactions_response = await getAllTransactions(filterParams);
            this.tableData = transactions_response.data;

            const categories_response = await getAllCategories();
            this.categories = categories_response.data;

            this.loading = false;
        },
    }
}
</script>